import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface IFooterProps {
  showDataProtection: boolean;
  showImprint: boolean;
  version: {
    backend: string;
    frontend: string;
  };
}

const linkFactory = (element: any) => styled(element).attrs(() => ({
  className: 'border-transparent italic text-black border-b-2',
}))`
  &:hover {
    border-color: ${props => props.theme.primary};
  }
`;
const FooterLink = linkFactory(Link);
const FooterOtherLink = linkFactory('a');

const Footer = ({ showDataProtection, showImprint, version }: IFooterProps) => (
  <div className="flex justify-between mt-16 pb-8">
    <div>
      Contact:{' '}
      <FooterOtherLink href="mailto: linkmanager-support@datacroft.de">
        linkmanager-support@datacroft.de
      </FooterOtherLink>
      <p className="text-xs opacity-50 mt-1">
        Current version:{' '}
        <i className="mr-1">
          frontend <strong>{version.frontend}</strong>
        </i>{' '}
        <i>
          backend <strong>{version.backend}</strong>
        </i>
      </p>
    </div>
    <div>
      {showDataProtection && (
        <FooterLink className="mr-4" to={'/data-protection'}>
          Data Protection
        </FooterLink>
      )}
      {showImprint && <FooterLink to={'/imprint'}>Imprint</FooterLink>}
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.tsx